import type { RootState } from '@shared/redux/root-state';

const isExpired = (jwt?: string | null) => {
  if (!jwt) return true;
  try {
    const [, payload] = jwt.split('.');
    const exp = JSON.parse(atob(payload)).exp as number;
    return Date.now() >= exp * 1000;
  } catch {
    return true;
  }
};

export const selectHasAccess = (s: RootState) =>
  Boolean(s.auth.authInfo?.access_token) && !isExpired(s.auth.authInfo?.access_token);

export const selectHasRefresh = (s: RootState) => Boolean(s.auth.authInfo?.refresh_token);

export const authSelectors = {
  selectIsAuthorized: (state: RootState) => selectHasAccess(state) || selectHasRefresh(state),
  selectAccessToken: (state: RootState) => state.auth.authInfo?.access_token,
  selectRefreshToken: (state: RootState) => state.auth.authInfo?.refresh_token,
  selectAuthInfo: (state: RootState) => state.auth.authInfo,
  selectUserInfo: (state: RootState) => state.auth.userInfo,
  selectCurrentOrganizationInfo: (state: RootState) => state.auth.currentOrganizationInfo,
  selectCurrentOrganizationId: (state: RootState) => state.auth.currentOrganizationInfo.id,
  selectSelfPermission: (state: RootState) => state.auth?.currentOrganizationInfo?.permission,
};
